<template>
    <div class="registerDialog">
        <el-dialog title="" :visible.sync="dialogVisible" :show-close="false" custom-class="customDialog" width="557px" top="8vh"
            :before-close="handleClose">
            <div class="mainContent">
                <div class="titileBox">
                    <div class="userInfo">用户信息注册</div>
                    <div class="text">通过审核后即可登录进行模拟考试练习</div>
                </div>
                <div class="dialogMain">
                    <el-form ref="registerForm" :model="registerForm" size="mini" :rules="registerRules" label-width="80px">
                        <div class="form-child-box">
                            <div class="form-left">
                                <el-form-item label="姓名" prop="name">
                                    <el-input v-model.trim="registerForm.name" size="mini" readonly placeholder="请输入姓名"
                                        onfocus="this.removeAttribute('readonly');"></el-input>
                                </el-form-item>
                                <!-- <el-form-item label="姓名拼音" prop="pinyin">
                                    <el-input v-model="registerForm.pinyin" size="mini" readonly placeholder="请输入姓名"
                                        onfocus="this.removeAttribute('readonly');"></el-input>
                                </el-form-item> -->
                                <el-form-item label="身份证号" prop="idCard">
                                    <el-input v-model.trim="registerForm.idCard" size="mini" readonly placeholder="请输入身份证号"
                                        onfocus="this.removeAttribute('readonly');"></el-input>
                                </el-form-item>
                            </div>
                            <!-- <div class="form-right">
                                <el-form-item label="" label-width="0" prop="photoUrl" ref="photoUrl">
                                    <el-upload
                                        class="avatar-uploader"
                                        :action="actionUrl"
                                        :show-file-list="false"
                                        :on-success="handleAvatarSuccess"
                                        :before-upload="beforeAvatarUpload">
                                        <img v-if="registerForm.photoUrl" :src="registerForm.photoUrl" class="avatar">
                                        <span v-else>
                                            <i class="el-icon-plus avatar-uploader-icon"></i>
                                            <p>上传一寸照片</p>
                                        </span>
                                    </el-upload>
                                </el-form-item>
                                

                            </div> -->
                        </div>
                       
                        <el-form-item label="就读院校" prop="orgData">
                            <el-select v-model="registerForm.orgData" filterable placeholder="请选择就读院校" clearable
                                value-key="deptId">
                                <el-option v-for="item in orgDataList" :key="item.deptId" :label="item.name"
                                    :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="专业" prop="major">
                            <el-input v-model.trim="registerForm.major" size="mini" readonly placeholder="请输入专业"
                                onfocus="this.removeAttribute('readonly');"></el-input>
                        </el-form-item>
                       
                        <!-- <el-form-item label="报考院校" prop="examOrgName">
                            <el-input v-model.trim="registerForm.examOrgName" size="mini" readonly
                                onfocus="this.removeAttribute('readonly');" placeholder="请输入意向报考院校名称"></el-input>
                        </el-form-item> -->
                        <div class="validBox">
                            <el-form-item label="手机号码" prop="mobile">
                                <el-input v-model.trim="registerForm.mobile" size="mini" :style="{ width: '375px' }" placeholder="请输入手机号"
                                    readonly onfocus="this.removeAttribute('readonly');"></el-input>
                            </el-form-item>
                            <div class="isVerifyCodeBox">
                                <el-form-item 
                                    label="" 
                                    label-width="0px"
                                    prop="verifyCode" style="margin-left:0px;">
                                    <el-input style="width:170px;margin-left: 20px;" readonly
                                        onfocus="this.removeAttribute('readonly');" placeholder="验证码"
                                        v-model.trim="registerForm.verifyCode"></el-input>
                                    <div class="timeBox"><el-button type="primary" size="mini" :disabled="disable"
                                            :class="{ codeGeting: isGeting }" @click="getVerifyCode">{{ getCode
                                            }}</el-button></div>
                                </el-form-item>
                            </div>
                        </div>
                        <el-form-item label="密码" prop="password">
                            <el-input v-model.trim="registerForm.password" size="mini" show-password readonly placeholder="请输入密码"
                                onfocus="this.removeAttribute('readonly');"></el-input>
                        </el-form-item>
                        <el-form-item label="重复密码" prop="repeatPwd">
                            <el-input v-model.trim="registerForm.repeatPwd" size="mini" show-password readonly placeholder="请重复输入密码"
                                onfocus="this.removeAttribute('readonly');"></el-input>
                        </el-form-item>
                        <!-- <el-input v-model="registerForm.name" size="mini"></el-input> -->
                        <!-- <div class="uploadBox">
                            <el-form-item label="证件上传" prop="photoFrontUrl" ref="photoFrontUrl">
                                <el-upload v-loading="imgLoadingOne" ref="upload" class="avatar-uploader"
                                    :action="actionUrl" :show-file-list="false" accept="image/png, image/jpeg, image/jpg"
                                    :on-success="handleAvatarSuccessOne" :before-upload="beforeAvatarUploadOne">
                                    <img v-if="registerForm.photoFrontUrl" :src="registerForm.photoFrontUrl" class="avatar">
                                    <div class="avatar-uploader-icon" v-else>
                                        <i class="el-icon-plus icontext"><br><span class="idCardText">身份证正面</span></i>
                                    </div>
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="" prop="photoBackUrl" ref="photoBackUrl">
                                <el-upload v-loading="imgLoadingTwo" ref="upload" class="avatar-uploader"
                                    :action="actionUrl" :show-file-list="false" accept="image/png, image/jpeg, image/jpg"
                                    :on-success="handleAvatarSuccessTwo" :before-upload="beforeAvatarUploadTwo">
                                    <img v-if="registerForm.photoBackUrl" :src="registerForm.photoBackUrl" class="avatar">
                                    <div class="avatar-uploader-icon" v-else>
                                        <i class="el-icon-plus icontext"><br><span class="idCardText">身份证反面</span></i>
                                    </div>
                                </el-upload>
                            </el-form-item>
                        </div> -->
                    </el-form>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <p>
                    <el-button size="mini" @click="() => { cancel() }">取 消</el-button>
                    <el-button 
                        size="mini" 
                        type="primary" 
                        :loading="btnLoading"
                        @click="confirmBtn">申 请</el-button>
                </p>
                <!-- <div style=""><div class="widget rich_text undefined hleft vtop " style="width: 742px; height: 165px; font-size: 14px; text-align: left; font-weight: normal; font-style: normal;"><div class="rich-text"><p style="line-height:0; margin-bottom:5px;" data-immersive-translate-effect="1" data-immersive_translate_walked="98314591-1986-481a-ba5d-b5210c8160ff"><span class="--mb--rich-text" data-boldtype="1" style="font-family:SourceHanSansSC; font-weight:700; font-size:12px; color:rgba(143,153,165,1); font-style:normal; letter-spacing:0px; line-height:12px; text-decoration:none;" data-immersive-translate-effect="1" data-immersive_translate_walked="98314591-1986-481a-ba5d-b5210c8160ff">注意说明</span><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:12px; color:rgba(143,153,165,1); font-style:normal; letter-spacing:0px; line-height:12px; text-decoration:none;" data-immersive-translate-effect="1" data-immersive_translate_walked="98314591-1986-481a-ba5d-b5210c8160ff">：</span></p><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:12px; color:rgba(143,153,165,1); font-style:normal; letter-spacing:0px; line-height:12px; text-decoration:none;">1.姓名拼音必须填写学生姓名的全拼，这个后续会印刷在证书上，一定要确保拼音准确，填写时姓和名用空格隔开，首字母大写，</span></p><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:12px; color:rgba(143,153,165,1); font-style:normal; letter-spacing:0px;margin-left: 10px; line-height:12px; text-decoration:none;">    例如：张三丰，拼音应该是：Zhang Sanfeng；库尔班·热合曼 ，拼音应该是：Kuerban Reheman。</span></p><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:12px; color:rgba(143,153,165,1); font-style:normal; letter-spacing:0px; line-height:12px; text-decoration:none;">2.学生照片标准请参照下列要求准备</span></p><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; margin-left: 10px; font-weight:400; font-size:12px; color:rgba(143,153,165,1); font-style:normal; letter-spacing:0px; line-height:12px; text-decoration:none;">1、照片格式：jpg、png</span></p><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:12px; color:rgba(143,153,165,1); font-style:normal; margin-left: 10px;letter-spacing:0px; line-height:12px; text-decoration:none;">    2、照片大小：5M 以内</span></p><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:12px; color:rgba(143,153,165,1); font-style:normal; letter-spacing:0px; line-height:12px; margin-left: 10px;text-decoration:none;">    3、照片像素：295*413</span></p><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:12px; color:rgba(143,153,165,1); font-style:normal; letter-spacing:0px; line-height:12px;margin-left: 10px; text-decoration:none;">    4、照片尺寸：2.7cmx3.8cm (宽*长)，标准一寸照片。</span></p><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:12px; color:rgba(143,153,165,1); font-style:normal; letter-spacing:0px; line-height:12px; margin-left: 10px;text-decoration:none;">    5、照片底色:红色</span></p><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:12px; color:rgba(143,153,165,1); font-style:normal; letter-spacing:0px; line-height:12px; text-decoration:none;"><br></span></p></div></div></div> -->
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Api from '@/api/fetch.js'
import qs from 'qs';
import { checkCardId,  checkPhone} from '@/utils/common.js'
export default {
    name: 'registerDialog',
    data() {
        let isRepeatPwd = (rule, value, callback) => {
            if (value !== this.registerForm.password) {
                callback(new Error("请输入相同的密码"));
            } else {
                callback();
            }
        };
        // eslint-disable-next-line no-unused-vars
        let isOrgData = (rule, value, callback) => {
            if (value.orgId == '') {
                callback(new Error("请选择就读院校"));
            } else {
                callback();
            }
        };
        let isPinYin = (rule, value, callback) => {
            const pinyinRegex = /^[A-Z][a-z]*\s[A-Z][a-z]*$/;

            if (pinyinRegex.test(value)) {
                callback(); // 拼音格式正确
            } else {
                callback(new Error("拼音格式错误！"));
            }
        };
        return {
            countDown: null,
            getCode: '获取验证码',
            isGeting: false,
            count: 60,
            disable: false,
            registerForm: {
                name: '',
                orgData: {
                    orgId: '',
                    orgName: '',
                },
                major: '',
                mobile: '',
                verifyCode: '',
                idCard: '',
                password: '',
                // pinyin: '', // 名字拼音
                // photoUrl: '', // 一寸照
                photoFrontUrl: '1',
                photoBackUrl: '1',
                examOrgName: '1'
            },
            registerRules: {
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: checkPhone, trigger: "blur" }
                ],
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                pinyin: [
                    { required: true, message: '请输入拼音', trigger: 'blur' },
                    {
                        validator: isPinYin,
                        trigger: "change",
                    },
                ],
                orgData: [
                    { required: true, message: '请选择就读院校', trigger: 'change' },
                    {
                        validator: isOrgData,
                        trigger: "change",
                    },
                ],
                examOrgName: { required: true, message: '请输入意向报考院校名称', trigger: 'change' },
                major: { required: true, message: '请输入专业', trigger: 'blur' },
                password: { required: true, message: '请输入密码', trigger: 'blur' },
                repeatPwd: [
                    { required: true, message: '请再次输入密码', trigger: 'blur' },
                    {
                        validator: isRepeatPwd,
                        trigger: "blur",
                    },
                ],
                verifyCode: { required: true, message: ' ', trigger: 'blur' },
                idCard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }, { validator: checkCardId, trigger: "blur", }],
                // photoUrl: { required: true, message: '请上传一寸照片', trigger: 'change' },
                photoFrontUrl: { required: true, message: '请输入身份证正面', trigger: 'change' },
                photoBackUrl: { required: true, message: '请输入身份证反面', trigger: 'change' },
            },


            orgDataList: [],
            // isCode: true,
            imgLoadingOne: false,
            imgLoadingTwo: false,
            btnLoading: false // 申请禁用标识
        };
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        }
    },

    mounted() {

    },

    computed: {
        actionUrl() {
            return process.env.VUE_APP_UPLOAD_API + '/upload/v2Upload'
        },
    },

    methods: {
        cancel() {
            this.$emit('changeDialogVisible', false);
            clearInterval(this.countDown)
            this.disable = false;
            this.isGeting = false
            this.getCode = '获取验证码';
            this.count = 60
        },
        getVerifyCode() {
            let mobile = this.registerForm.mobile
            if (mobile && /^1[0-9]{10}$/.test(mobile)) {
                this.countDown = setInterval(() => {
                    if (this.count < 1) {
                        this.isGeting = false
                        this.disable = false
                        this.getCode = '获取验证码'
                        this.count = 6
                        clearInterval(this.countDown)
                    } else {
                        this.isGeting = true
                        this.disable = true
                        this.getCode = this.count-- + 's后重发'
                    }
                }, 1000)
                this.sendCode()
            } else {
                // this.$message.error('请先输入手机号码')
                this.$refs.registerForm.validateField("mobile", (phoneError) => {
                    if (!phoneError) {
                        console.log('error submit!!');
                        return false
                    }
                })
            }
        },
        sendCode() {
            let params = {
                phone: this.registerForm.mobile
            }
            Api.sendCode(qs.stringify(params)).then(res => {
                if (res.code == '0') {
                    this.$message.success(res.msg || '发送成功')
                } else {
                    this.$message.error(res.msg || '验证码发送不成功')
                }
            })
        },
        confirmBtn() {
            this.btnLoading = true
            this.$refs.registerForm.validate((valid) => {
                if (valid) {
                    // if (this.isCode) {
                    //     this.$message.error('请获取验证码')
                    //     return false
                    // }
                    // console.log(this.registerForm, 'this.registerForm')
                    let params = {
                        ...this.registerForm,
                        orgId: this.registerForm.orgData.deptId,
                        orgName: this.registerForm.orgData.name,
                        orgData: undefined
                    }
                    // eslint-disable-next-line no-unused-vars
                    this.$refs.registerForm.validateField("verifyCode", (phoneError) => {
                        if (this.registerForm.verifyCode) {
                            Api.addRegister(params).then(res => {
                                if (res.code == '0') {
                                    this.$message.success(res.msg || '注册成功')
                                    this.$emit('changeDialogVisible', false)
                                    // 验证码归0
                                    clearInterval(this.countDown)
                                    this.disable = false;
                                    this.isGeting = false
                                    this.getCode = '获取验证码';
                                    this.count = 60
                                } else {
                                    this.$message.error(res.msg || '注册失败')
                                }
                                this.btnLoading = false
                            })

                        } else {
                            this.$message.error('请发送验证码')
                            this.btnLoading = false
                            console.log('ERR')
                            return false
                        }
                    })


                }else{
                    this.btnLoading = false
                }
            })

        },
        beforeAvatarUploadOne(file) {
            let isImg;
            if (file.name.indexOf(".jpeg") != -1 || file.name.indexOf(".jpg") != -1 || file.name.indexOf(".png") != -1) {
                isImg = true
            } else {
                isImg = false
            }
            this.imgLoadingOne = true;
            if (!isImg) {
                this.$message.error('请上传 .jpeg, .jpg 或 .png 图片!');
                this.imgLoadingOne = false;
            }
            return isImg;
        },
        // 证件照上传前
        beforeAvatarUpload(file) {
            console.log(file);
            let type = file.name.split('.')
            console.log(type);
            if (!['jpg', 'png'].includes(type[type.length - 1])) {
                this.$message.error('图像格式错误，只能上传 jpg / png 格式图片！');
                return false
            }else if(file.size > 5242880 ){
                this.$message.error('图像过大，超出5MB限制！');
                return false
            }
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, img.width, img.height);

                        const imageData = ctx.getImageData(0, 0, img.width, img.height).data;
                        const redPixels = this.countRedPixels(imageData);
                        // 根据实际情况调整判断红底的比例阈值
                        const redRatio = redPixels / (imageData.length / 4);
                        console.log(redRatio);
                        if (redRatio > 0.1) {
                        // 红底判断通过，可以上传
                            this.imageUrl = e.target.result;
                            resolve();
                        } else {
                            this.$message.error('请上传红底图片！');
                            reject();
                        }
                    };

                    img.src = e.target.result;
                };
                reader.readAsDataURL(file);
            });
        },
        countRedPixels(imageData) {
            let redPixels = 0;
            for (let i = 0; i < imageData.length; i += 4) {
                const red = imageData[i];
                const green = imageData[i + 1];
                const blue = imageData[i + 2];
                // 根据实际情况调整判断红底的阈值
                if (red > 100 && green < 100 && blue < 100) {
                    redPixels++;
                }
            }
            return redPixels;
        },
        // 用户一寸照片上传
        handleAvatarSuccess(res, file) {
            console.log(file);
            this.$refs.photoUrl.clearValidate()
            // checkRedBackground( res.data.url, (isRedBackground)=>{
            //     console.log(isRedBackground);
            // })
            this.registerForm.photoUrl = res.data.url;
        },
        handleAvatarSuccessOne(res) {
            this.$refs.photoFrontUrl.clearValidate()
            this.imgLoadingOne = false;
            this.registerForm.photoFrontUrl = res.data.url;
        },
        beforeAvatarUploadTwo(file) {
            let isImg;
            if (file.name.indexOf(".jpeg") != -1 || file.name.indexOf(".jpg") != -1 || file.name.indexOf(".png") != -1) {
                isImg = true
            } else {
                isImg = false
            }
            this.imgLoadingTwo = true;
            if (!isImg) {
                this.$message.error('请上传 .jpeg, .jpg 或 .png 图片!');
                this.imgLoadingTwo = false;
            }
            return isImg;
        },
        handleAvatarSuccessTwo(res) {
            this.$refs.photoBackUrl.clearValidate()
            this.imgLoadingTwo = false;
            this.registerForm.photoBackUrl = res.data.url;
        },
        getOrgdataList() {
            Api.getorgDataList({
                provinceId: 14
            }).then(res => {
                if (res.code == '0') {
                    this.orgDataList = res.data
                } else {
                    this.$message.error(res.msg || '获取就读院校失败')
                }
            })
        },
        handleClose() {

        },
    },
};
</script>

<style lang="scss" scoped>
.mainContent {
    padding: 0 20px 0;
    width: 100%;
    height: 400px;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
    box-sizing: border-box;
}

/deep/.customDialog {
    .el-dialog__body {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }

    .titileBox {
        width: 100%;
        height: 60px;
        text-align: center;

        .userInfo {
            font-weight: 700;
            font-size: 16px;
        }

        .text {
            font-size: 12px;
        }
    }

    .el-dialog__footer {
        text-align: center;
        // height: 320px;
    }
}

.dialogMain {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 100%;
    height: 450px;

    .form-child-box{
        display: flex;
        .form-left{
            width: 100%;
        }
        // .form-right{
        //     margin-left: 15px;
        // }
    }
    .validBox {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;

        /deep/.isVerifyCodeBox {
            position: absolute;
            top: 0;
            right: 0;

            .timeBox {
                position: absolute;
                top: 0;
                right: 0;
            }
        }

        .codeGeting {
            background: #cdcdcd;
            border-color: #cdcdcd;
        }
    }

    /deep/.el-select {
        width: 100%;
    }

    /deep/.el-form-item__label {
        padding-right: 0;
        // margin-right: 10px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        background-color: rgba(243, 245, 247, 1);
    }

    /deep/ .el-form{
        > .el-form-item .el-form-item__content, 
        .validBox > .el-form-item .el-form-item__content,
        .form-child-box .form-left .el-form-item .el-form-item__content{
            margin-left: 100px !important;
        }
        .avatar-uploader{
            background-color: #f1f1f1;
        }
    }
    //deep/.el-form-item__content {
     //   margin-left: 107px !important;
    //}

    .uploadBox {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .iconBox {
            text-align: center;
            display: flex;
            justify-content: center;
            // flex-direction: column;
            align-items: center;
        }

        .icontext {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            flex-direction: column;
            color: #606266;
            .idCardText {
                font-size: 12px;    
                color: #606266;
            }
        }
    }

    .avatar-uploader {
        // @include wh(160px,160px);
        width: 130px;
        height: 130px;
        background-color: #f1f1f1;
        text-align: center;
        // padding-top: 30px;
        box-sizing: border-box;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        
    }

    .avatar-uploader:hover {
        opacity: .8;
        
    }

    .avatar-uploader-icon {
        // padding-top: 34px;
        box-sizing: border-box;
        font-size: 28px;
        color: #000000;
        margin-top: 30px;
        //width: 130px;
       // height: 130px;
        //line-height: 130px;
        // background: rgba(156, 197, 253, 0.2);
        // opacity:0.16;
        text-align: center;
        //border: 1px dashed #ccc;
    }

    .avatar {
        width: 130px;
        height: 130px;
        display: block;
    }
}</style>